import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { Route, Switch } from 'react-router-dom';
import { askUnsetTab } from './routers/settings';
import ReactGA from 'react-ga';

/* Imports routes */
import RouteHome from './routes/routeHome'
import RouteSearch from './routes/routeSearch'
import RouteData from './routes/routeData'
import RouteResume from './routes/routeResume'
import RouteConfirmation from './routes/routeConfirmation'
import RoutePageText from './routes/routePageText'
import RouteSectionText from './routes/routeSectionText'
import RouteFaqs from './routes/routeFaqs'
import RouteContact from './routes/routeContact'
import RouteTable from './routes/routeTable'
import RouteLegal from './routes/routeLegal'

/* Import material ui */
//import injectTapEventPlugin from 'react-tap-event-plugin';
import { MuiThemeProvider } from 'material-ui/styles';
import Theme from './theme'
import getMuiTheme from 'material-ui/styles/getMuiTheme';

//injectTapEventPlugin(); // Needed for onTouchTap for Material UI

class App extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  // [ga] tracking function
  fireTracking() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    // console.log('[GA] Tracked -> ' + window.location.pathname + window.location.search);
  }

  componentWillMount() {
    // [ga] initialize tracking
    ReactGA.initialize('UA-115956218-1');

    this.unlisten = this.context.router.history.listen((location, action) => {
      this.props.askUnsetTab(this.props.settings);

      // [ga] track every history change
      this.fireTracking();
    });
  }
  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    // [ga] track the first time we get there!
    this.fireTracking();
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(Theme)}>
        <div className="App">
          <Switch>
            <Route path="/es/search" render={() => <RouteSearch />} />
            <Route path="/es/data" render={() => <RouteData />} />
            <Route path="/es/resume" render={() => <RouteResume />} />
            <Route path="/es/confirmation" render={({match}) => <RouteConfirmation match={match}/>} />

            <Route path="/es" exact render={() => <RouteHome />} />
            <Route path="/es/atencion-al-cliente" render={() => <RouteContact />} />
            <Route path="/es/viajar-en-ferry" render={() => <RouteFaqs />} />
            <Route path="/es/localiza-tu-billete" render={() => <RouteSectionText />} />
            <Route path="/es/sobre-romeu-ferries" render={() => <RoutePageText />} />
            <Route path="/es/ferries-desde-alicante" render={() => <RouteTable city="alicante" isOrigin={true} />} />
            <Route path="/es/ferries-desde-barcelona" render={() => <RouteTable city="barcelona" isOrigin={true} />} />
            <Route path="/es/ferries-a-oran" render={() => <RouteTable city="oran" isOrigin={false} />} />
            <Route path="/es/ferries-a-mostaganem" render={() => <RouteTable city="mostaganem" isOrigin={false} />} />
            <Route path="/es/ferries-a-argel" render={() => <RouteTable city="argel" isOrigin={false} />} />

            <Route path="/es/aviso-legal" render={() => <RouteLegal selection="warning" />} />
            <Route path="/es/condiciones-del-servicio" render={() => <RouteLegal selection="conditions" />} />
            <Route path="/es/politica-de-privacidad" render={() => <RouteLegal selection="privacy" />} />
            <Route path="/es/politica-de-cookies" render={() => <RouteLegal selection="cookies" />} />

            <Route path="/fr/search" render={() => <RouteSearch />} />
            <Route path="/fr/data" render={() => <RouteData />} />
            <Route path="/fr/resume" render={() => <RouteResume />} />
            <Route path="/fr/confirmation" render={() => <RouteConfirmation />} />

            <Route path="/fr" exact render={() => <RouteHome />} />
            <Route path="/fr/attention-au-client" render={() => <RouteContact />} />
            <Route path="/fr/voyage-en-ferry" render={() => <RouteFaqs />} />
            <Route path="/fr/reperez-votre-billet" render={() => <RouteSectionText />} />
            <Route path="/fr/a-propos-des-ferries-romeu" render={() => <RoutePageText />} />
            <Route path="/fr/itineraires-et-horaires" render={() => <RouteTable />} />
            <Route path="/fr/ferries-d-alicante" render={() => <RouteTable city="alicante" isOrigin={true} />} />
            <Route path="/fr/ferries-d-barcelona" render={() => <RouteTable city="barcelona" isOrigin={true} />} />
            <Route path="/fr/ferries-a-oran" render={() => <RouteTable city="oran" isOrigin={false} />} />
            <Route path="/fr/ferries-a-mostaganem" render={() => <RouteTable city="mostaganem" isOrigin={false} />} />
            <Route path="/fr/ferries-a-argel" render={() => <RouteTable city="argel" isOrigin={false} />} />

            <Route path="/fr/avis-juridique" render={() => <RouteLegal selection="warning" />} />
            <Route path="/fr/conditions-d-utilisation" render={() => <RouteLegal selection="conditions" />} />
            <Route path="/fr/politique-de-confidentialite" render={() => <RouteLegal selection="privacy" />} />
            <Route path="/fr/politique-de-cookies" render={() => <RouteLegal selection="cookies" />} />

            <Route render={() => <div>404 Page not found</div>}/> { /* TODO: MAKE DECENT 400 PAGE */ }
          </Switch>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default connect(
  (state) => ({ settings: state.settings }),
  { askUnsetTab }
)(App)



// WEBPACK FOOTER //
// ./src/shared/App.js